import { APICore } from "./apiCore";

const api = new APICore()

function getProductos(params:any): any{
    const baseUrl = "/productos"
    return api.get(baseUrl,params)
}

function getProducto(id:String): any{
    const baseUrl = `/productos/${id}`
    return api.get(baseUrl,{})
}
function syncProductos(params:any): any{
    const baseUrl = "/productos/sync"
    return api.get(baseUrl,{})
}

export {getProductos,getProducto,syncProductos}